import {ActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ActDecorator';
import {SignalEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter';
import {strictGameEmitter, GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';

/**
 * Extend AsyncActDecorator if you want to block the chain of other Acts.
 * It is a promise like behaviour.
 */
export abstract class AsyncActDecorator<T = GameOnlyEventMap> extends ActDecorator {
    readonly emitter: SignalEventEmitterWrapper<T> = new SignalEventEmitterWrapper(strictGameEmitter, {signal: this.abortSignal, owner: this}) as any;
    public abstract getName(): string;

    /**
     * this function is called when normal queue state is executing
     */
    public async execute(): Promise<void> {

    }

    /**
     * this function is called when queue state was interrupted
     * and this act is current
     */
    public async skip(): Promise<void> {

    }

    /**
     * this function is called if queue state was interrupted
     * before executing this act
     */
    public async forceSkip(): Promise<void> {

    }

    public removeAllListeners(): void {
        super.removeAllListeners();
        this.emitter.offAllByOwner();
    }
}